<template>
  <el-dialog v-el-drag-dialog
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             title="打印工单"
             width="900px"
             height="600px">
    <div style="width: 700px;" id="printProductionContent1">
      <div v-for="(productInfo,index) in productInfos" :key="index" id="printProductionCards">
        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3" style="width: 20%">
              <div :id="(() => 'qrCode2_'+productInfo.pkid)()" align="center"/>
            </td>
            <td colspan="3" style="text-align: center; font-weight: 700; font-size: 20px">工单</td>
          </tr>
          <tr>
            <td colspan="2">派工单号：{{productInfo.billNo}}</td>
            <td>工单号：{{productInfo.productionOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="2">物料名称：{{productInfo.materialName}}</td>
            <td>物料编号：{{productInfo.materialNo}}</td>
          </tr>
          <tr>
            <!--            <td style="width: 20%">工单类型：{{productInfo.prodOrderTypeName}}</td>-->
            <td colspan="3" style="width: 40px;font-size: 14px;">规格：{{productInfo.specification}}</td>
            <td>
              <div style="display: flex;">
                <div style="text-align: center;" :id="(() => 'barCodeM2_'+productInfo.pkid)()"/>
                <div style="margin-top: 18px;margin-left: 5px;font-size: 14px;">报错入口</div>
              </div>
<!--              <div>-->
<!--                <img style="max-width: 200px;margin-left: 5px;height: 18px;"-->
<!--                     :id="(() => 'barCodeM2_'+productInfo.pkid)()">-->
<!--                <div style="text-align: center;margin-top: -4px;">报错入口</div>-->
<!--              </div>-->

            </td>
          </tr>
          <tr>
            <td colspan="2">工艺路线：{{productInfo.routingName}}</td>
            <td>工单数量：{{productInfo.quantity}}</td>
            <td>工作中心：{{productInfo.workCenterName}}</td>
          </tr>
          <tr>
            <td colspan="2">开工时间：{{productInfo.planStartTime}}</td>
            <td colspan="2">完工时间：{{productInfo.planFinishTime}}</td>
          </tr>
          <tr>
            <td colspan="2">生产任务制单人：{{productInfo.productCreatorName}}</td>
            <td colspan="2">销售订单制单人：{{productInfo.orderCreatorName}}</td>
          </tr>
          <tr>
            <td colspan="2">销售单号：{{productInfo.salesOrderNo}}</td>
            <td colspan="2">ERP单号：{{productInfo.erpSalesOrderNo}}</td>
          </tr>
          <tr>
            <td colspan="2" style="width: 50%">合同号：{{productInfo.customerContractNo}}</td>
            <td colspan="2" style="width: 50%">项目名称：{{productInfo.projectName}}</td>
          </tr>
          <tr>
            <td colspan="2">客户名称：{{productInfo.customerName}}</td>
            <td colspan="2">最终客户：{{productInfo.finalCustomerName}}</td>
          </tr>
          <tr>
            <td colspan="4">订单备注：{{productInfo.salesOrderMaterialNote}}</td>
          </tr>
        </table>
        <!--        03.03-->
        <table style="width: 100%;margin-top: 10px;" cellpadding="0" cellspacing="0"
               v-if="productInfo.materialTypeNo==='03.03'">
          <tr>
            <td rowspan="2" style="text-align: center">工序</td>
            <td colspan="5" style="text-align: center">钣金下料车间</td>
            <td colspan="8" style="text-align: center">钣金成型车间</td>
          </tr>
          <tr>
            <td style="text-align: center">编程</td>
            <td style="text-align: center">数冲</td>
            <td style="text-align: center">激光</td>
            <td style="text-align: center">雕刻</td>
            <td style="text-align: center">剪板</td>
            <td style="text-align: center">打磨</td>
            <td style="text-align: center">焊接</td>
            <td style="text-align: center">喷涂</td>
            <td style="text-align: center">折弯</td>
            <td style="text-align: center">普冲</td>
            <td style="text-align: center">机加工</td>
            <td style="text-align: center">压铆</td>
            <td style="text-align: center">包装</td>
          </tr>
          <tr>
            <td style="text-align: center">签名</td>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
            <td/>
          </tr>
        </table>
        <div v-if="productInfo.filePath" style="width: 100%;text-align: center;margin-top: 10px"
             v-loading="fileLoading">
          <img :src="productInfo.filePath" width="800px" height="600px">
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  import JsBarcode from "jsbarcode";

  export default {
    data() {
      return {
        dialogVisible: false,
        // productInfo: {},
        productInfos: [],
        fileLoading: false,
        ids: [],
        printOption: {
          id: "printProductionContent1",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      arrayBufferToBase64(filepath, buffer) {
        var binary = "";
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        // return window.btoa(binary);
        filepath = "data:image/png;base64," + window.btoa(binary);
      },
      open(productInfos) {
        this.ids = [];
        this.productInfos = [];
        this.productInfos = JSON.parse(JSON.stringify(productInfos));
        this.dialogVisible = true;

        this.$nextTick(() => {
          this.productInfos.forEach((item) => {
            if (item.finalCustomerName) {
              item.finalCustomerName = item.finalCustomerName + "(" + item.finalCustomerOuterNo + ")";
            }
            if (item.customerName) {
              item.customerName = item.customerName + "(" + item.customerOuterNo + ")";
            }
            this.ids.push(item.pkid);
            document.getElementById("qrCode2_" + item.pkid).innerHTML = "";
            this.bindQRCode(item.billNo, item.pkid);

            document.getElementById("barCodeM2_" + item.pkid).innerHTML = "";
            // this.bindBarCode(item.materialNo, item.pkid);
            this.bindQRCode1(item.materialNo, item.pkid);

            if (item.filePath) {
              this.fileLoading = true;
              this.$http.exportFile("basic", "files/getDownloadImg", {key: item.filePath}).then((res) => {
                let blob = new Blob([res.data]);
                item.filePath = URL.createObjectURL(blob);
                this.fileLoading = false;
              }).catch(() => {
                this.fileLoading = false;
              });
            }
          });
        });
      },

      bindQRCode(row, id) {
        let text = row;
        new QRCode(document.getElementById("qrCode2_" + id), {
          text: text,
          width: 140,
          height: 140,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      bindQRCode1(row, id) {
        let text = row;
        new QRCode(document.getElementById("barCodeM2_" + id), {
          text: text,
          width: 50,
          height: 50,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCodeM2_" + id), row, {
          text: text,
          // width: 3,
          height: 20,
          margin: 0,
          displayValue: false,
        });
      },

      print() {
        // document.body.innerHTML = document.getElementById("printProductionCards").parentNode.innerHTML;
        // window.print();
        // window.location.reload();
        this.$http.get("basic", `taskDispatchBills/updatePrint/${this.ids}`).then(() => {
        });
        return false;
      },
    },
  };
</script>
<style lang="scss" scoped>
#printProductionCards {
  //width: 76mm;
  //height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 1px solid #111;
      border-right: 0;
      border-bottom: 0;
      padding: 5px 5px;
      box-sizing: border-box;
      font-size: 10px;
      //min-width: 140px;
      white-space: pre-wrap;
    }

    tr {
      width: 700px;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }

    .el-checkbox {
      margin-right: 5px;
      top: 1px;
    }
  }
}

@media print {
  table {
    td {
      word-break: break-all;
    }
  }
}
</style>
